import React, { Dispatch, SetStateAction, useMemo, useState } from "react";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import ModalExportExcel from "../../../components/common/modal/ModalExportExcel";
import { CategoryType } from "../../../types/category.type";

interface IExportExcel {
  category: CategoryType;
  query?: { [key: string]: any };
  totalRows?: number;
  filenameExport?: string;
  setLoad: Dispatch<SetStateAction<number>>;
}

const limit = 500;

function ExportExcel({
  category,
  query,
  totalRows = 0,
  filenameExport,
  setLoad,
}: IExportExcel) {
  const [openExportExcel, setOpenExportExcel] = useState<boolean>(false);
  const [loadingExport, setLoadingExport] = useState<boolean>(false);

  const maxPage = useMemo(() => {
    let result = 1;
    if (totalRows % limit > 0) {
      result += 1;
    }
    return result;
  }, [totalRows]);

  return (
    <>
      <ModalExportExcel
        files={maxPage}
        condition={{
          limit,
          q: query,
        }}
        loading={loadingExport}
        setLoading={setLoadingExport}
        open={openExportExcel}
        handleClose={() => setOpenExportExcel(false)}
        apiCode={category?.apiCode}
        filenameExport={filenameExport || `${category?.apiCode}_report.xlsx`}
      />
      {loadingExport && (
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            position: "fixed",
            zIndex: 100,
            bottom: 0,
            right: "5%",
            px: 2,
            py: 1,
            backgroundColor: "secondary.main",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <Typography sx={{ color: "common.white" }}>
            Xuất {`${category?.apiCode}_export.xlsx`}
          </Typography>
          <CircularProgress
            style={{ width: "20px", height: "20px" }}
            sx={{ color: "common.white" }}
          />
        </Stack>
      )}
      {/* Button */}
      <Button
        onClick={() => setOpenExportExcel(true)}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          boxShadow: "none",
          color: "common.white",
          textTransform: "none",
          "&:hover": { boxShadow: "none" },
        }}
      >
        Xuất excel
      </Button>
    </>
  );
}

export default ExportExcel;
